// @flow

const GMAIL = 'gmail.com';
const YAHOO = 'yahoo.com';
const HOTMAIL = 'hotmail.com';

// Gathered from a query, the top email domains per country, sorted from most popular to least
// https://docs.google.com/spreadsheets/d/1HoMHP2hlfPtJDiqRyr-Dg5o4ZNGpHxKW5jK5qH_iN7E/edit#gid=400706363
const COUNTRY_TO_TOP_DOMAINS = {
  AR: [GMAIL, HOTMAIL, 'yahoo.com.ar'],
  AU: [GMAIL, HOTMAIL, 'bigpond.com'],
  BR: [GMAIL, HOTMAIL, 'yahoo.com.br'],
  CA: [GMAIL, HOTMAIL, YAHOO],
  DE: [GMAIL, 'web.de', 'gmx.de'],
  ES: [GMAIL, HOTMAIL, 'hotmail.es'],
  FR: [GMAIL, 'hotmail.fr', 'orange.fr'],
  GB: [GMAIL, 'hotmail.co.uk', 'hotmail.com'],
  IN: [GMAIL, YAHOO, 'rediffmail.com'],
  IT: [GMAIL, 'libero.it', 'hotmail.it'],
  JP: [GMAIL, 'yahoo.co.jp', 'ezweb.ne.jp'],
  MX: [GMAIL, HOTMAIL, 'outlook.com'],
  US: [GMAIL, HOTMAIL, YAHOO],
  DEFAULT: [GMAIL, HOTMAIL, YAHOO],
};

export default function getDomainRecommendations(country?: string) {
  return country && country.toUpperCase() in COUNTRY_TO_TOP_DOMAINS
    ? COUNTRY_TO_TOP_DOMAINS[country.toUpperCase()]
    : COUNTRY_TO_TOP_DOMAINS.DEFAULT;
}
